export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'e4ca5630-7837-440d-85aa-4c87471a46c8';
export const MODAL_CLOSE_SEC = 2.5;
